var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.11 28.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffd500;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m11.51,8.37c.67-2.42,2.19-4.28,3.27-5.35.63-.62.66-1.62.07-2.28l-.18-.2c-.5-.55-1.3-.7-1.95-.36C-.26,6.99-.1,16.23.03,17.8c0,.17-.03.34-.03.52C0,23.88,4.51,28.38,10.06,28.38s10.06-4.51,10.06-10.06c0-5.07-3.75-9.25-8.62-9.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m35.49,8.37c.67-2.42,2.19-4.28,3.27-5.35.63-.62.66-1.62.07-2.28l-.18-.2c-.5-.55-1.3-.7-1.95-.36-12.98,6.81-12.81,16.05-12.69,17.62,0,.17-.03.34-.03.52,0,5.56,4.51,10.06,10.06,10.06s10.06-4.51,10.06-10.06c0-5.07-3.75-9.25-8.62-9.95Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/Quote.94f8dbc5ec47d4ab8e76995466992aec.svg";
export { ForwardRef as ReactComponent };